import { render, staticRenderFns } from "./ExtraImgProduct.vue?vue&type=template&id=5e303494&scoped=true&"
import script from "./ExtraImgProduct.vue?vue&type=script&lang=js&"
export * from "./ExtraImgProduct.vue?vue&type=script&lang=js&"
import style0 from "./ExtraImgProduct.vue?vue&type=style&index=0&id=5e303494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e303494",
  null
  
)

export default component.exports